import { ForgeAgent, ForgeAvatarBuilder } from "@supernova-studio/model";
import { z } from "zod";

export const DTOForgeAgent = ForgeAgent;
export const DTOForgeAvatarBuilder = ForgeAvatarBuilder;

export const DTOCreateForgeAgent = DTOForgeAgent.omit({ projectId: true });
export const DTOUpdateForgeAgent = DTOCreateForgeAgent.extend({ id: z.string() });

export const DTOCreateForgeAgentResponse = z.object({
  agent: DTOForgeAgent,
});

export const DTOUGetForgeAgentResponse = z.object({
  agent: DTOForgeAgent.nullable(),
});

export const DTOUpdateForgeAgentResponse = z.object({
  agent: DTOForgeAgent.nullable(),
});

export const DTOForgeAgentsListResponse = z.object({
  agents: z.array(DTOForgeAgent),
});

export const DTODeleteForgeAgentResponse = z.object({
  ok: z.literal(true),
});

export type DTOForgeAgent = z.infer<typeof DTOForgeAgent>;
export type DTPGetForgeAgentResponse = z.infer<typeof DTOUGetForgeAgentResponse>;
export type DTOForgeAvatarBuilder = z.infer<typeof DTOForgeAvatarBuilder>;
export type DTOCreateForgeAgent = z.infer<typeof DTOCreateForgeAgent>;
export type DTOUpdateForgeAgent = z.infer<typeof DTOUpdateForgeAgent>;
export type DTOCreateForgeAgentResponse = z.infer<typeof DTOCreateForgeAgentResponse>;
export type DTOUpdateForgeAgentResponse = z.infer<typeof DTOUpdateForgeAgentResponse>;
export type DTODeleteForgeAgentResponse = z.infer<typeof DTODeleteForgeAgentResponse>;
export type DTOForgeAgentsListResponse = z.infer<typeof DTOForgeAgentsListResponse>;
